import { useEffect } from 'react';

import { useCollapsiblePanelContext } from './CollapsiblePanel.context';

type UsePanelContentsSubscribe = {
  name: string;
  value: number | string | boolean | undefined;
  invalid: boolean;
  isOptional: boolean;
};

const usePanelContentsSubscribe = (props: UsePanelContentsSubscribe) => {
  const { name, invalid, value, isOptional } = props;
  const { addField, removeField } = useCollapsiblePanelContext();

  useEffect(() => {
    if (name) {
      addField({ path: name, invalid, value, isOptional });
    }

    return () => {
      if (name) {
        removeField({ path: name, invalid, value, isOptional });
      }
    };
  }, [name, addField, removeField, invalid, value, isOptional]);
};

export { usePanelContentsSubscribe };
